import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from '@nu-art/thunderstorm-frontend/index';
import { PanelKey_Home, PanelKey_Inbox } from '../../../_shared.js';
import { ModuleFE_EMInterface } from '@app/advisor-frontend';
import './AdvisorMiniPanel_Inbox.scss';
import { Inbox_Filtering } from '../../../_enum/inbox-filter/Inbox_Filtering.js';
import { ICONS } from '@app/styles';
import { AdvisorMiniPanel } from '../AdvisorMiniPanel/AdvisorMiniPanel.js';
import { ModuleFE_AdvisorMini } from '../../../modules/ModuleFE_AdvisorMini.js';
import { Component_Inbox } from '../../components/inbox/Component_Inbox/Component_Inbox.js';
export class AdvisorMiniPanel_Inbox extends AdvisorMiniPanel {
    static defaultProps = {
        panelKey: PanelKey_Inbox,
        panelType: 'secondary',
    };
    //######################### Life Cycle #########################
    __onReadOnlyChanged() {
        this.reDeriveState();
    }
    deriveStateFromProps(nextProps, state) {
        state = super.deriveStateFromProps(nextProps, state); // call super derive to resolve readonly mode into the state
        state.readonly = ModuleFE_EMInterface.isReadonly();
        return state;
    }
    //######################### Logic #########################
    refreshAdvisor = async () => {
        if (ModuleFE_EMInterface.isPostDisposition() || ModuleFE_EMInterface.isReadonly())
            return;
        return ModuleFE_EMInterface.updateEncounterApis.refreshFhirData();
    };
    onPanelClick = () => ModuleFE_AdvisorMini.openPanel(this.props.panelKey);
    //######################### Render - Header #########################
    renderHeader_Title = () => 'Orders';
    renderHeader_Tail = () => {
        if (this.state.readonly)
            return;
        return _jsxs(_Fragment, { children: [_jsx(Button, { variant: 'header-button', onClick: this.refreshAdvisor, children: _jsx(ICONS.sync.component, {}) }), _jsx(Inbox_Filtering, { variant: 'concise', mini: true }), _jsx(ICONS.advisor_avn_close.component, { onClick: () => ModuleFE_AdvisorMini.openPanel(PanelKey_Home) })] });
    };
    //######################### Render - Sub Header #########################
    renderSubHeader = undefined;
    //######################### Render - Content #########################
    _renderContent(scrollRef) {
        return _jsx(Component_Inbox, { scrollRef: scrollRef });
    }
    renderContent = () => _jsx(_Fragment, {});
    //######################### Render - Footer #########################
    renderFooter = undefined;
}
//# sourceMappingURL=AdvisorMiniPanel_Inbox.js.map